import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// hooks
import { useFieldType, useSaveFieldValue } from 'hooks'
// types
import { IField } from 'types/graphql'
// containers
import TableFormContainer from 'containers/Risks/RiskForm'
// constants
import { Forms } from 'constants/forms'
// components
import FieldContent from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/FieldContent'
import HistoryButton from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/RiskTemplateField/components/HistoryButton'
// context
import { RiskViewContext } from 'containers/Risks/RiskView/Risk/layers'
// views
import { TableFieldWrapper } from './views'

interface Props {
  field: IField
}

const templateSelector = formValueSelector(Forms.RISK_TEMPLATE_FORM)

const TableField: React.FC<Props> = ({ field }) => {
  const { riskSelector } = React.useContext(RiskViewContext)

  const { fieldValue } = useSelector((state) => ({
    fieldValue: (riskSelector || templateSelector)(state, field.id)
  }))

  const { isFieldLink } = useFieldType(field)

  if (isFieldLink) {
    return <TableFormContainer field={field} />
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useSaveFieldValue({ field, value: fieldValue, name: field.id })

  return (
    <TableFieldWrapper>
      <FieldContent name={`${field.name}.value`} field={field} />
      <HistoryButton field={field} fieldValueId={fieldValue?.fieldValueId} />
    </TableFieldWrapper>
  )
}

export default TableField
